import { defineMessages } from 'react-intl';

export default defineMessages({
    //DE15292 text to show on avatar links
    userProfile:{
        id: 'portal.index.User Profile',
        defaultMessage: 'User Profile',
    },
    faq: {
        id: 'portal.index.FAQ',
        defaultMessage: 'FAQ',
    },
    error: {
        id: 'portal.index.Error',
        defaultMessage: 'Error',
    },
    errorMessage: {
        id: 'portal.index.Sorry, an error occurred. You can try again later or contact us.',
        defaultMessage:
            'Sorry, an error occurred. You can try again later or contact us.',
    },
    errorMetadataMessage: {
        id: 'portal.index.No product metadata please refer to README for building metadata.',
        defaultMessage:
            'No product metadata please refer to README for building metadata.',
    },
    searchPlaceHolder: {
        id: 'gateway.views.search-quote.Search by account or policy number.',
        defaultMessage: 'Search...',
    },
    searchTooltipMessage: {
        id: 'gateway.views.search-quote.Search.Tooltip.',
        defaultMessage: 'Search by policy number, or a first or last name associated with the policy, or a mailing/property address. Incomplete entries will also display results.',
    },
    login: {
        id: 'auth.components.AuthStatus.Login',
        defaultMessage: 'Login',
    },
    account: {
        id: 'auth.components.AuthStatus.Account',
        defaultMessage: 'Account',
    },
    preferences: {
        id: 'auth.components.AuthStatus.Preferences',
        defaultMessage: 'Preferences',
    },
    logOut: {
        id: 'auth.components.AuthStatus.Log out',
        defaultMessage: 'Log out',
    },
    quoteAnyAccount: {
        id: 'gateway.views.new-quote.Quote for Any Account',
        defaultMessage: 'Quote for Any Account',
    },
    quoteThisAccount: {
        id: 'gateway.views.new-quote.Quote for This Account',
        defaultMessage: 'Quote for This Account',
    },
    viewAll: {
        id: 'gateway.views.new-quote.View all',
        defaultMessage: 'View all matches of: {Number}',
    },
    // accountsTab: {
    //     id: 'app.html.index.Accounts',
    //     defaultMessage: 'Accounts',
    // },
    // policiesTab: {
    //     id: 'app.html.index.Policies',
    //     defaultMessage: 'Policies',
    // },
    // claimsTab: {
    //     id: 'app.html.index.Claims',
    //     defaultMessage: 'Claims',
    // },
    // activitiesTab: {
    //     id: 'app.html.index.Activities',
    //     defaultMessage: 'Activities',
    // },
    // commissionTab: {
    //     id: 'app.html.index.Commission',
    //     defaultMessage: 'Commission',
    // },
    account: {
        id: 'gateway.views.search.Account',
        defaultMessage: 'Account',
    },
    policy: {
        id: 'gateway.views.search.Policy',
        defaultMessage: 'Policy',
    },
    startNewQuote:{
        id: 'gateway.views.Start New Quote',
        defaultMessage: 'Start New Quote'
    },
    addAccountSecurity:{
        id: 'portal.index.Add Account Security',
        defaultMessage: 'Add Account Security',
    },
});
